export interface ProductEstimate {
  product_id: number;
  product_name: string;
  unit: string;
  estimated_quantity: number;
  lower_bound?: number;
  upper_bound?: number;
  confidence_level: 'high' | 'medium' | 'low' | null;
  action_status?: 'start_now' | 'start_soon' | 'prepare' | 'wait' | 'no_prep';
  cooking_time?: number;
  cooking_time_minutes?: number;
  suggested_start_time?: string;
  suggested_start_time_formatted?: string;
  minutes_until_start?: number;
  prediction_range?: {
    pessimistic: number;
    most_likely: number;
    optimistic: number;
    confidence: string;
  };
  prediction_details?: {
    lower_bound?: number;
    upper_bound?: number;
    trend_component?: number;
    seasonal_component?: number;
  };
  ingredients?: Array<{
    product_id: number;
    product_name: string;
    quantity: number;
    unit: string;
  }>;
  is_fallback?: boolean;
  recommendation_min?: number;
  recommendation_max?: number;
  peak_type?: 'peak' | 'pre-peak' | 'valley' | 'very-low' | 'normal';
  is_peak?: boolean;
  peak_message?: string;
  peak_warning?: string | null;
  explanation?: string;
}

export function getConfidenceColor(level: 'high' | 'medium' | 'low' | null): string {
  if (!level) return '#6B7280';
  const colors = {
    high: '#10B981',
    medium: '#F59E0B',
    low: '#EF4444'
  };
  return colors[level];
}

export function getConfidenceLabel(level: 'high' | 'medium' | 'low' | null): string {
  if (!level) return '';
  const labels = {
    high: 'ALTA',
    medium: 'MEDIA',
    low: 'BAJA'
  };
  return labels[level];
}

export function formatTime(datetime: string): string {
  const date = new Date(datetime);
  return date.toLocaleTimeString('es-MX', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
}
